module.exports = __webpack_public_path__ + "static/media/inf_51pog59p.6dde4f3c.mp3";